import { createApp } from "vue/dist/vue.esm-browser.prod";
import { createClient } from "@sanity/client";
import imageUrlBuilder from "@sanity/image-url";

createApp({
	data() {
		return {
			items: null,
			loading: true,
		};
	},
	mounted: async function () {
		const client = createClient({
			projectId: "9fvagzap",
			dataset: "production",
			useCdn: true, // set to `false` to bypass the edge cache
			apiVersion: "2023-05-03", // use current date (YYYY-MM-DD) to target the latest API version
		});

		try {
			const posts = await client.fetch(
				'*[_type == "proyectos"] | order(_updatedAt desc)'
			);

			this.items = posts;
			this.loading = false;
		} catch (error) {
			console.log(error);
			this.loading = true;
		}
	},
	methods: {
		urlFor(source) {
			const builder = imageUrlBuilder({
				projectId: "9fvagzap",
				dataset: "production",
			});

			return builder.image(source);
		},
	},
}).mount("#app");
